module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.newMater()
      }
    }
  }, [_vm._v("新建明细")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteRow(scope.$index, scope.row, _vm.returnData)
            }
          }
        }, [_vm._v("移除")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCode",
      "width": "150",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "modelName",
      "width": "150",
      "label": "型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "number",
      "width": "200",
      "label": "出库数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          attrs: {
            "controls-position": "right",
            "size": "small",
            "min": 1,
            "max": scope.row.inventoryATotal - scope.row.broughtTotal
          },
          on: {
            "change": function($event) {
              return _vm.changeNumber()
            }
          },
          model: {
            value: (scope.row.inboundSum),
            callback: function($$v) {
              _vm.$set(scope.row, "inboundSum", $$v)
            },
            expression: "scope.row.inboundSum"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "price",
      "width": "200",
      "formatter": _vm.addCommas,
      "label": "出库单价(元)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "size": "small"
          },
          on: {
            "change": function($event) {
              return _vm.changeAmount()
            }
          },
          model: {
            value: (scope.row.price),
            callback: function($$v) {
              _vm.$set(scope.row, "price", $$v)
            },
            expression: "scope.row.price"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "200",
      "prop": "availQuantity",
      "label": "可出库数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "amount",
      "width": "200",
      "formatter": _vm.addCommas,
      "label": "合计金额(元)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.amount = Number(scope.row.price) * Number(scope.row.inboundSum)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.addSerial(scope.row)
            }
          }
        }, [_vm._v("添加序列号")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "totalDiv"
  }, [_c('small', [_vm._v("数量：")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.totalCount))]), _vm._v("     \n        "), _c('small', [_vm._v("总计：")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.totalMoney))]), _vm._v(" 元\n    ")]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新建物料信息",
      "visible": _vm.dislogMater,
      "close-on-click-modal": false,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogMater = $event
      },
      "close": function($event) {
        return _vm.emptyNew()
      }
    }
  }, [_c('el-row', [_c('el-col', [_c('ul', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('span', {
    staticClass: "fl headerSpan"
  }, [_vm._v("品牌")]), _vm._v(" "), _vm._l((_vm.brandLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "fl listPart",
      class: {
        active: _vm.activeBrandIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.selectBrand(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.brandName))])
  })], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.categoryLists.length !== 0) ? _c('ul', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('span', {
    staticClass: "fl headerSpan"
  }, [_vm._v("品类")]), _vm._v(" "), _vm._l((_vm.categoryLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "fl listPart",
      class: {
        active: _vm.activeCategoryIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.selectCategory(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.categoryName))])
  })], 2) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.modelLists.length !== 0) ? _c('ul', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('span', {
    staticClass: "fl headerSpan"
  }, [_vm._v("型号")]), _vm._v(" "), _vm._l((_vm.modelLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "fl listPart",
      class: {
        active: _vm.activeModelIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.selectModel(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.modelName))])
  })], 2) : _vm._e()]), _vm._v(" "), _c('el-form', {
    ref: "modelForm",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      "inline": true,
      "label-width": "75px",
      "model": _vm.modelForm,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "label": "物料编码"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择物料编号",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.getMaterNumberList
    },
    model: {
      value: (_vm.modelForm.materialCode),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "materialCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.materialCode"
    }
  }, _vm._l((_vm.newData), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.materialCode,
        "value": item.materialCode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "label": "物料名称"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择物料名称",
      "clearable": ""
    },
    on: {
      "change": _vm.getMaterNumberList
    },
    model: {
      value: (_vm.modelForm.materialName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "materialName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.materialName"
    }
  }, _vm._l((_vm.newData), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.materialName,
        "value": item.materialName
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.newData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "brandName",
      "label": "品牌"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "categoryName",
      "label": "品类"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "modelName",
      "label": "型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCode",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addEventFormSubmitBtn()
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyNew()
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加序列号",
      "visible": _vm.dislogSerial,
      "close-on-click-modal": false,
      "width": "580px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogSerial = $event
      },
      "close": function($event) {
        return _vm.cancelSerial()
      }
    }
  }, [_c('el-row', [_c('el-input', {
    ref: "inputRef",
    staticStyle: {
      "margin-bottom": "20px",
      "width": "97%"
    },
    attrs: {
      "autofocus": _vm.dislogSerial,
      "placeholder": "请扫码或输入序列号"
    },
    on: {
      "input": _vm.scanCodeFuc
    },
    model: {
      value: (_vm.codeValue),
      callback: function($$v) {
        _vm.codeValue = $$v
      },
      expression: "codeValue"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("序列号")])], 2), _vm._v(" "), _c('el-transfer', {
    ref: "myTransfer",
    attrs: {
      "filterable": "",
      "left-default-checked": [],
      "right-default-checked": [],
      "render-content": _vm.renderFunc,
      "titles": ['可添加的序列号', '已添加的序列号'],
      "button-texts": ['删除', '添加'],
      "format": {
        noChecked: '${total}',
        hasChecked: '${checked}/${total}'
      },
      "data": _vm.codeData
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.codeList),
      callback: function($$v) {
        _vm.codeList = $$v
      },
      expression: "codeList"
    }
  }, [_c('el-button', {
    staticClass: "transfer-footer",
    attrs: {
      "slot": "left-footer",
      "type": "text",
      "size": "small"
    },
    slot: "left-footer"
  }, [_vm._v("合计:" + _vm._s(_vm.codeData.length))]), _vm._v(" "), _c('el-button', {
    staticClass: "transfer-footer",
    attrs: {
      "slot": "right-footer",
      "type": "text",
      "size": "small"
    },
    slot: "right-footer"
  }, [_vm._v("已添加:" + _vm._s(_vm.codeList.length))])], 1), _vm._v(" "), _c('div', {
    staticClass: "number-content"
  }, [_c('p', [_vm._v("需添加序列号合计 " + _vm._s(_vm.unScanNumber) + " 个")]), _vm._v(" "), _c('p', [_vm._v("已添加序列号合计 " + _vm._s(_vm.codeList.length) + " 个")]), _vm._v(" "), _c('p', [_vm._v("可添加序列号合计 " + _vm._s(_vm.codeData.length) + " 个")])])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addSerialComformBtn()
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancelSerial()
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.isSubmit
    },
    nativeOn: {
      "click": function($event) {
        return _vm.DetermineSave()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.isSubmit
    },
    nativeOn: {
      "click": function($event) {
        return _vm.DetermineSave1()
      }
    }
  }, [_vm._v("暂存")]), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.isSubmit
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteSerial.apply(null, arguments)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "split-button": "",
      "type": "primary",
      "trigger": "click"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.pageStatus) + "\n        "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeSave()
      }
    }
  }, [_vm._v("离开当前页面")])], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelOrder()
      }
    }
  }, [_vm._v("取消新建")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-8a118e1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editAccessStore/materialAccess.vue
// module id = 1725
// module chunks = 0